module.exports = "<p class=\"text-center\" style=\"margin:0; width: 128px\">{{$ctrl.vm.name}} {{$ctrl.vm.surname}}</p>\n<div class=\"text-center\">\n\t<img ng-src=\"https://www.gravatar.com/avatar/{{$ctrl.vm.gravatar}}?s=128&d=mm\" style=\"width: 128px; height: 128px;\"/>\n</div>\n<p class=\"text-center\" style=\"margin:0; width: 128px\"><b style=\"font-style:italic\">{{$ctrl.vm.nick}}</b></p>\n<p class=\"text-center\" style=\"margin:0; width: 128px\">{{$ctrl.vm.club}}</p>"


//////////////////
// WEBPACK FOOTER
// ./client/app/common/avatarpopuptemplate.html
// module id = 523
// module chunks = 0